module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAeFBMVEUAAABBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiND////p8vr0+PxdmtdpodpkntlZl9bv9fvi7fjZ5/a/1/C20u2yz+ykxumfw+dJjtL3+v3G2/GSu+SQueSAsOBC1OVzAAAAEnRSTlMAJO/5jfPMt65OMzDlyI5RSPTSYArZAAAApklEQVQY03WR6RKCIBCAV0A8SdvQDrPSrvd/w1pxhWbs+8PyDezsAY5CmVKWRhXgiVJk0ohlLdAjaicziSEym77H+EtMSRJ/b+2TjgQgD2V/f1GQwyaQV+wtRQoMy+NX3k4HCjWUi7ywRAHSy6EhSYDrYOzsODR77gQ0Em/bnheJeq7h0ZFk1FzvjkEi595CkrU5bKP1mU1U4eu4+r8L3psWKDTv7QOIyRjUOkcOUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_edit_hover.png
// module id = e3XM
// module chunks = 9